export default {
  label: {
    id: 'resolution_flow_return_confirmation_page_cta_get_more_help',
    defaultMessage: 'Get more help',
  },
}
